import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d3596ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "catalogueid" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxPosition = _resolveComponent("DxPosition")!
  const _component_DxToolbarItem = _resolveComponent("DxToolbarItem")!
  const _component_DxEditPopup = _resolveComponent("DxEditPopup")!
  const _component_DxRequiredRule = _resolveComponent("DxRequiredRule")!
  const _component_DxValidator = _resolveComponent("DxValidator")!
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DxTextBox = _resolveComponent("DxTextBox")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_DxEditPopup, {
      key: _ctx.renderKey,
      visible: _ctx.popupVisible,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.popupVisible) = $event)),
      "drag-enabled": true,
      width: _ctx.designConfig.popUpWidth,
      height: _ctx.designConfig.popUpHeight,
      "show-title": true,
      title: _ctx.selectTitle,
      onShown: _ctx.onShown,
      onHidden: _ctx.onHidden,
      onContentReady: _ctx.onPopUpReady,
      parentModel: _ctx.parentModel
    }, {
      default: _withCtx(() => [
        _createVNode(_component_DxPosition, {
          my: "center",
          at: "center",
          of: "window"
        }),
        _hoisted_1,
        _createVNode(_component_DxToolbarItem, {
          toolbar: "bottom",
          location: "after",
          widget: "dxButton",
          options: _ctx.okButtonOptions,
          disabled: _ctx.okButtonDisabled
        }, null, 8, ["options", "disabled"]),
        _createVNode(_component_DxToolbarItem, {
          toolbar: "bottom",
          location: "after",
          widget: "dxButton",
          options: _ctx.cancelButtonOptions
        }, null, 8, ["options"])
      ]),
      _: 1
    }, 8, ["visible", "width", "height", "title", "onShown", "onHidden", "onContentReady", "parentModel"]),
    _createVNode(_component_DxTextBox, {
      class: "SelectControl-textbox",
      value: _ctx.desc,
      placeholder: _ctx.placeholderValue,
      "read-only": true,
      "element-attr": _ctx.textBoxClass,
      disabled: _ctx.disabled,
      stylingMode: _ctx.stylingMode
    }, {
      default: _withCtx(() => [
        _createVNode(_component_DxValidator, { "validation-group": _ctx.validationGroup }, {
          default: _withCtx(() => [
            (!_ctx.hasEmptyValue)
              ? (_openBlock(), _createBlock(_component_DxRequiredRule, { key: 0 }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["validation-group"]),
        (_ctx.hasEmptyValue && !_ctx.isEmptyValue)
          ? (_openBlock(), _createBlock(_component_DxButton, {
              key: 0,
              options: _ctx.clearButton,
              name: "clearButton",
              location: "after",
              "styling-mode": "outlined"
            }, null, 8, ["options"]))
          : _createCommentVNode("", true),
        _createVNode(_component_DxButton, {
          options: _ctx.moreButton,
          name: "moreButton",
          location: "after",
          "styling-mode": "outlined"
        }, null, 8, ["options"])
      ]),
      _: 1
    }, 8, ["value", "placeholder", "element-attr", "disabled", "stylingMode"])
  ]))
}